export const SET_STUDENTS = 'set_students'
export const RESET_STUDENTS = 'reset_students'
export const SET_CURRENT_STUDENT = 'set_current_student'
export const SET_ASSESSMENT_DATA = 'set_assessment_data'
export const SET_OVERVIEW_DATA = 'set_overview_data'
export const RESET_OVERVIEW_DATA = 'reset_overview_data'
export const SET_PREV_OVERVIEW_DATA = 'set_prev_overview_data'
export const SET_STUDENT_CLASSES = 'set_student_classes'
export const LOADING_AVERAGE_SCORE_SKILLS = 'loading_average_score_skills'
export const SET_AVERAGE_SCORE_SKILLS = 'set_average_score_skills'
export const SET_PENTAGON = 'set_pentagon'
export const SET_IELTS = 'set_ielts'
export const SET_DUMMY_EMAIL_CREDENTIAL = 'set_dummy_email_credential'
export const SET_DUMMY_EMAIL_CREDENTIALS = 'set_dummy_email_credentials'
export const RESET_DUMMY_EMAIL_CREDENTIALS = 'reset_dummy_email_credentials'
export const SET_CHART_DATE = 'set_current_chart_date'
export const RESET_CHART_DATE = 'reset_current_chart_date'
